/** Вращение «идёт»: при «уменьшить движение» — без вращения (contracts/ui.md §6). */
export function Spinner() {
  return (
    <span
      aria-hidden
      className="inline-block h-3 w-3 shrink-0 animate-spin rounded-full border-2 border-ink-3 border-t-transparent motion-reduce:animate-none"
    />
  );
}
